import { TEAMS_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    teamList: [],
    getTeamsLoading: false,
    getTeamsSuccess: false,
    getTeamsFailure: false,
    getTeamsError: null,
    addTeamLoading: false,
    addTeamSuccess: false,
    addTeamFailure: false,
    addTeamError: null,
    editTeamLoading: false,
    editTeamSuccess: false,
    editTeamFailure: false,
    editTeamError: null,
    deleteTeamLoading: false,
    deleteTeamSuccess: false,
    deleteTeamFailure: false,
    deleteTeamError: null,
}

export const teamReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TEAMS_REQUEST.GET_ALL_TEAMS_REQUEST:
            return {
                ...state,
                getTeamsLoading: true,
                getTeamsSuccess: false,
                getTeamsFailure: false,
                getTeamsError: null,
            }
        case TEAMS_REQUEST.GET_ALL_TEAMS_SUCCESS:
            return {
                ...state,
                getTeamsLoading: false,
                getTeamsSuccess: true,
                getTeamsFailure: false,
                getTeamsError: null,
                teamList: action.payload
            }
        case TEAMS_REQUEST.GET_ALL_TEAMS_FAILURE:
            return {
                ...state,
                getTeamsLoading: false,
                getTeamsSuccess: false,
                getTeamsFailure: true,
                getTeamsError: action.payload,
            }
        case TEAMS_REQUEST.ADD_NEW_TEAM_REQUEST:
            return {
                ...state,
                addTeamLoading: true,
                addTeamSuccess: false,
                addTeamFailure: false,
                addTeamError: null,
            }
        case TEAMS_REQUEST.ADD_NEW_TEAM_SUCCESS:
            var t = state.teamList;
            t.push(action.payload);
            return {
                ...state,
                addTeamLoading: false,
                addTeamSuccess: true,
                addTeamFailure: false,
                addTeamError: null,
                teamList: t,
            }
        case TEAMS_REQUEST.ADD_NEW_TEAM_FAILURE:
            return {
                ...state,
                addTeamLoading: false,
                addTeamSuccess: false,
                addTeamFailure: true,
                addTeamError: action.payload,
            }
        case TEAMS_REQUEST.EDIT_TEAM_REQUEST:
            return {
                ...state,
                editTeamLoading: true,
                editTeamSuccess: false,
                editTeamFailure: false,
                editTeamError: null,
            }
        case TEAMS_REQUEST.EDIT_TEAM_SUCCESS:
            var x = state.teamList;
            for (let i = 0; i < x.length; i++) {
                if (x[i].teamId === action.payload.teamId) {
                    x[i] = action.payload
                    
                }
                // console.log(x[i], "checkcheck");
            }
            // console.log(x.length, "xlength");
            
            return {
                ...state,
                editTeamLoading: false,
                editTeamSuccess: true,
                editTeamFailure: false,
                editTeamError: null,
                teamList: x,
            }
        case TEAMS_REQUEST.EDIT_TEAM_FAILURE:
            return {
                ...state,
                editTeamLoading: false,
                editTeamSuccess: false,
                editTeamFailure: true,
                editTeamError: action.payload,
            }
        case TEAMS_REQUEST.DELETE_TEAM_REQUEST:
            return {
                ...state,
                deleteTeamLoading: true,
                deleteTeamSuccess: false,
                deleteTeamFailure: false,
                deleteTeamError: null,
            }
        case TEAMS_REQUEST.DELETE_TEAM_SUCCESS:
            var y = state.teamList;
            for (let i = 0; i < y.length; i++) {
                if (y[i].teamId === action.payload) {
                    y.splice(i, 1);
                }
            }
            return {
                ...state,
                deleteTeamLoading: false,
                deleteTeamSuccess: true,
                deleteTeamFailure: false,
                deleteTeamError: null,
                teamList: y,
            }
        case TEAMS_REQUEST.DELETE_TEAM_FAILURE:
            return {
                ...state,
                deleteTeamLoading: false,
                deleteTeamSuccess: false,
                deleteTeamFailure: true,
                deleteTeamError: action.payload,
            }
        default:
            return state;
    }
}